<script>
import CriarDespedida from './CriarDespedida.vue';
export default {
    components: { CriarDespedida }
  }
</script>

<template>
  <CriarDespedida />
  
</template>